// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';

import { flexCenter, flexVerticalMiddle } from '../../../utils/style';

export const StyledHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 2.75rem;
  z-index: 11;
  background-color: ${(props) => props.theme.colors.greys.white};
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid ${(props) => props.theme.colors.greys.grey20};
  padding: 0 1rem;
  ${flexVerticalMiddle}
  justify-content: space-between;
`;

export const StyledLeftContent = styled.div`
  ${flexVerticalMiddle}
`;

export const StyledRightContent = styled.div`
  ${flexVerticalMiddle}
`;

export const StyledLogo = styled.a`
  margin-right: 0.75rem;
`;

export const StyledTitle = styled.p`
  font-size: ${(props) => props.theme.fontSizes.exSmall.fontSize};
  font-weight: bold;
`;

export const StyledTestEnvTag = styled.div`
  background-color: ${(props) => props.theme.colors.greys.white};
  border: 1px solid ${(props) => props.theme.colors.error.primary};
  color: ${(props) => props.theme.colors.error.primary};
  padding: 0.25rem 0.5rem;
  font-size: ${(props) => props.theme.fontSizes.small.fontSize};
  ${flexCenter}
`;
